import { useRouteError } from 'react-router-dom';

export const BubbleRouteError = () => {
  const error = useRouteError();
  throw error;
};
